import type { PageConfig } from '../types';

export const overviewPageConfig: PageConfig = {
  id: 'overview',
  tabLabel: 'Overview',
  sections: [
    {
      id: 'hero',
      layout: 'grid-1',
      items: [{ kind: 'metric', id: 'sales_influenced', span: 'full' }],
    },
    {
      id: 'revival-stats',
      layout: 'grid-3',
      items: [
        { kind: 'metric', id: 'cold_leads_revived' },
        { kind: 'metric', id: 'conversion_rate' },
        { kind: 'metric', id: 'oldest_lead_days_to_revival' },
      ],
    },
    {
      id: 'breakdown-trio',
      layout: 'grid-3',
      items: [
        { kind: 'metric', id: 'revived_sales_by_vehicle_model' },
        { kind: 'metric', id: 'revival_prior_crm_status_share' },
        { kind: 'metric', id: 'revived_sales_by_content_theme' },
      ],
    },
    {
      id: 'dealership-basics',
      overline: 'YOUR DEALERSHIP',
      title: 'The basics that feed the cycle',
      action: {
        label: 'See full scorecard',
        navigation: { type: 'L3', tab: 'your-dealership' },
      },
      layout: 'grid-3',
      items: [
        { kind: 'metric', id: 'lead_capture_missing_email_rate' },
        { kind: 'metric', id: 'lead_capture_missing_voi_rate' },
        { kind: 'metric', id: 'unsubscribe_rate' },
      ],
    },
    {
      id: 'no-signal-to-signal',
      overline: 'FROM NO SIGNAL TO SIGNAL',
      title: 'Where did the revivals come from?',
      layout: 'grid-3',
      items: [
        {
          kind: 'metric',
          id: 'revived_sales_from_leads_older_than_90d_share',
          presentation: { detailLevel: 'summary' },
        },
        {
          kind: 'metric',
          id: 'revived_sales_marked_dead_in_crm_share',
          presentation: { detailLevel: 'summary' },
        },
        {
          kind: 'metric',
          id: 'revived_sales_no_prior_relationship_share',
          presentation: { detailLevel: 'summary' },
        },
      ],
    },
  ],
};
